import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {HEADER_PROPTYPES} from '../constants/header';

import ConnectedHeaderBackground from '../containers/ConnectedHeaderBackground';
import ConnectedHeaderMadLibs from '../containers/ConnectedHeaderMadLibs';

import HeaderTitle from './HeaderTitle';

import './Header.scss';


export default class Header extends Component {
    static propTypes = {
        // eslint-disable-next-line
        history: PropTypes.object,
        header: PropTypes.shape(HEADER_PROPTYPES),
        clickCTASeasonal: PropTypes.func,
    }

    render() {
        const {
            history,
            header,
            clickCTASeasonal,
        } = this.props;

        const feedHeaderClassNames = classNames([
            'feed-header',
            'eds-l-mn-pad-hor-3',
            'eds-l-md-pad-hor-3',
            'eds-l-mw-pad-hor-3',
            'eds-l-ln-pad-hor-3',
            'eds-l-lg-pad-hor-3',
            'eds-l-lw-pad-hor-3',
        ]);

        let imageAttributionComponent = null;

        if (header.attribution) {
            imageAttributionComponent = (
                <div className="feed-header__attribution eds-text-bs">
                    {header.attribution}
                </div>
            );
        }

        return (
            <section className={feedHeaderClassNames}>
                <ConnectedHeaderBackground type="MainHeaderBackground" />

                <div className="feed-header__content eds-text-color--white">
                    <div className="eds-g-cell eds-g-cell-12-12 eds-g-cell-sw-6-12 eds-g-cell-mn-7-12 eds-g-cell-md-8-12 eds-g-cell--has-overflow">
                        <HeaderTitle header={header} clickCTASeasonal={clickCTASeasonal} />
                    </div>
                    <div className="eds-g-cell eds-g-cell-12-12 eds-g-cell-sw-6-12 eds-g-cell-mn-5-12 eds-g-cell-md-4-12 eds-g-cell--has-overflow">
                        <ConnectedHeaderMadLibs history={history} />
                    </div>

                    {imageAttributionComponent}
                </div>
            </section>
        );
    }
}
